import React from "react";
import {Icon, TabControlButton, TabControlPage} from "peggirkit";
import {UserIcon} from "@heroicons/react/20/solid";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {useIntl} from "react-intl";
import CustomerDetails from "@widgets/pos/order/customer/CustomerDetails";

const CustomerTab = (tabProps: OrderEditorTabProps) => {
    const intl = useIntl();

    return (
        <TabControlPage
            tabButton={
                <TabControlButton iconBefore={<Icon icon={UserIcon}/>}>
                    {intl.formatMessage({id: "customer-details"})}
                </TabControlButton>
            }
        >
            <CustomerDetails {...tabProps} />
        </TabControlPage>
    );
};

export default CustomerTab;